export const TABBABLE_ELEMENT_SELECTOR = 'button, input, a, select';
const USABLENET_ASSISTIVE_ENABLED = 'UsableNetAssistiveEnabled';
/**
 * Returns whether the browser settings require reduced/no animations
 *
 */
export function preventAnimation() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches || accessibilityFeaturesEnabled();
}
/**
 * Fires when the accessibility widget posts the UsableNet "enabled" message.
 * Returns a Subscribable that callers can subscribe and unsubscribe from.
 *
 */
export function accessibilityEnabledListener() {
    return {
        subscribe(listener) {
            const onMessage = (event) => {
                if (event.data === USABLENET_ASSISTIVE_ENABLED) {
                    listener();
                }
            };
            window.addEventListener('message', onMessage);
            return () => window.removeEventListener('message', onMessage);
        },
    };
}
/**
 * returns whether the user has enabled accessibility features.
 * can be paired with a listener, as the class might not be applied by the time this method is executed
 * @see {@link accessibilityEnabledListener}
 *
 */
function accessibilityFeaturesEnabled() {
    return document.querySelector('html').classList.contains("un-assistive");
}
export function toggleAccessibleIcon(display) {
    const icon = getAccessibleIcon();
    let isDisplayed;
    if (icon) {
        if (display === 'show') {
            isDisplayed = true;
        }
        else if (display === 'hide') {
            isDisplayed = false;
        }
        else {
            const currentDisplayValue = icon.style.getPropertyValue('display');
            isDisplayed = currentDisplayValue === 'none' ? true : false;
        }
        if (isDisplayed) {
            icon.style.removeProperty('display');
        }
        else {
            icon.style.setProperty('display', 'none', 'important');
        }
    }
}
function getAccessibleIcon() {
    return document.getElementById('usntA40Toggle');
}
